import { localUrl as appLocalUrl } from './app-path.js';
import SessionManager from './session-manager';
import Main from './main';
import { trackGa4CatalogEvent, trackGa4ElementEvent } from './analytics/ga4-event-tracker';

const Plans = {
  plans: {
    monthly: null,
    yearly: null,
  },
  currentCycle: 'yearly',

  init(plansData) {
    this.plans = plansData;
    this.initPriceToggle();
    this.initPlanSelection();
    this.initFreePlanCta();
    this.changePricingCycle('yearly');
    this.trackInitialViewItem();
  },

  initPriceToggle() {
    const toggleButtons = document.querySelectorAll('.price-btn');

    toggleButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const cycle = btn.dataset.cycle;
        if (cycle) {
          this.changePricingCycle(cycle);
        }
      });
    });
  },

  initPlanSelection() {
    const selectButton = document.querySelector(
      '.btn-plan[onclick*="selectPlan"]',
    );

    if (selectButton) {
      selectButton.removeAttribute('onclick');

      selectButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.selectPlan();
      });
    }
  },

  initFreePlanCta() {
    const freeButton = document.querySelector('.plan-card.free .btn-plan');
    if (freeButton) {
      freeButton.addEventListener('click', () => {
        trackGa4ElementEvent('cta_click', 'Card_FreePlan_Button_CTA');
      });
    }
  },

  trackInitialViewItem() {
    const plan = this.plans[this.currentCycle];
    if (plan) {
      this.trackViewItem(plan, this.currentCycle);
    }
  },

  trackViewItem(plan, cycle) {
    if (!plan) return;

    const identity = this.getTrackingIdentity();
    const viewItemId = cycle === 'monthly'
      ? 'Card_PremiumPlan_Switcher_Monthly'
      : 'Card_PremiumPlan_Switcher_Yearly';
    const normalizedPrice = this.normalizePrice(plan.price);

    trackGa4CatalogEvent('view_item', {
      ...identity,
      id: viewItemId,
      item_type: 'plan',
      items: [
        {
          item_id: String(plan.id),
          item_name: String(plan.name || 'Plano Premium'),
          item_brand: 'Climatempo+',
          item_category: 'subscription',
          item_category2: cycle,
          item_category3: '',
          item_category4: '',
          item_category5: '',
          item_variant: cycle,
          price: normalizedPrice,
          quantity: 1,
          item_list_name: 'plans_page',
          item_list_id: 'plans',
          index: cycle === 'monthly' ? 0 : 1,
        },
      ],
    });
  },

  changePricingCycle(cycle) {
    if (!this.plans[cycle]) return;

    this.currentCycle = cycle;

    document.querySelectorAll('.price-btn').forEach((btn) => {
      btn.classList.remove('active');
      if (btn.dataset.cycle === cycle) {
        btn.classList.add('active');
      }
    });

    const monthlyEl = document.querySelector('.monthly-price');
    const yearlyEl = document.querySelector('.yearly-price');

    if (cycle === 'monthly') {
      if (monthlyEl) monthlyEl.style.display = 'flex';
      if (yearlyEl) yearlyEl.style.display = 'none';
    } else {
      if (monthlyEl) monthlyEl.style.display = 'none';
      if (yearlyEl) yearlyEl.style.display = 'flex';
    }

    this.trackViewItem(this.plans[cycle], cycle);
  },

  getTrackingIdentity() {
    const sessionUserId = SessionManager.getUserData()?.userId;
    let iumc = null;

    try {
      const raw = localStorage.getItem('ct_mc');
      if (raw) {
        const parsed = JSON.parse(raw);
        iumc = parsed?.mcid || null;
      }
    } catch (_) {
      iumc = null;
    }

    return {
      user_id: sessionUserId || undefined,
      userid: iumc || undefined,
    };
  },

  normalizePrice(value) {
    const numberValue = Number(value);
    if (!Number.isFinite(numberValue)) {
      return undefined;
    }

    return Number(numberValue.toFixed(2));
  },

  selectPlan() {
    const plan = this.plans[this.currentCycle];

    if (!plan) {
      alert('Plano não disponível no momento');
      return;
    }

    // Verificar se o usuário está autenticado usando SessionManager
    const isAuthenticated = SessionManager.isAuthenticated();
    const normalizedPrice = this.normalizePrice(plan.price);

    trackGa4CatalogEvent('select_item', {
      ...this.getTrackingIdentity(),
      item_type: 'subscription_plan',
      items: [
        {
          item_id: String(plan.id),
          item_name: String(plan.name || 'Plano Premium'),
          item_variant: this.currentCycle,
          price: normalizedPrice,
          quantity: 1,
        },
      ],
    });

    if (isAuthenticated) {
      // Usuário autenticado: redirecionar para checkout
      window.location.href = appLocalUrl(`/checkout?plan_id=${encodeURIComponent(plan.id)}`);
    } else {
      const redirectTo = appLocalUrl(`/checkout?plan_id=${encodeURIComponent(plan.id)}`);
      window.location.href = appLocalUrl(`/login?redirect=${encodeURIComponent(redirectTo)}`);
    }
  },
};

document.addEventListener('DOMContentLoaded', () => {
  Main.init();

  if (window.plansData) {
    Plans.init(window.plansData);
  }
});

export default Plans;
